import { useEffect, useState } from "react";

const CurrencyInput = ({ postToDB, putToDB, initialFieldData, fieldDataExists, data, readOnly, odooData, hasOdooMapping }) => {
	const [currentValue, setCurrentValue] = useState("");
	const [currencyFormat, setCurrencyFormat] = useState("");

	useEffect(() => {
		let newValue = "";
		if (fieldDataExists) {
			newValue = initialFieldData.value;
		}

		if (hasOdooMapping) {
			if (odooData && odooData.odoo_value !== "failedtogetdataforpmscode400") {
				newValue = odooData.odoo_value;
			} else if (odooData && odooData.odoo_value === "failedtogetdataforpmscode400") {
				if (fieldDataExists) {
					newValue = initialFieldData.value;
				}
			} else {
				newValue = "";
			}
		}
		setCurrentValue(newValue);
	}, [initialFieldData, fieldDataExists, odooData, hasOdooMapping]);

	useEffect(() => {
		if (currentValue) {
			setCurrencyFormat(
				currentValue
					.toString()
					.replace(/[^0-9]/g, "")
					.replace(/^/, "$")
					.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
			);
		} else {
			setCurrencyFormat("");
		}
	}, [currentValue]);

	const sendToDb = () => {
		if (initialFieldData && currentValue === initialFieldData.value) {
			return;
		}
		if (fieldDataExists === false && currentValue !== "") {
			postToDB(currentValue.replaceAll(/\$|,/g, ""));
		} else if (initialFieldData && currentValue !== initialFieldData.value) {
			putToDB(currentValue.replaceAll(/\$|,/g, ""));
		}
	};

	if (readOnly) {
		return (
			<div>
				<p className={"rounded-lg border border-2 p-2 w-full border-gray bg-gray-100"}>{currencyFormat || "\u00A0"}</p>
			</div>
		);
	}

	return (
		<form>
			<input
				type="text"
				value={currencyFormat}
				onChange={(e) => setCurrentValue(e.target.value.toString().replace(/[^0-9]/g, ""))}
				onBlur={() => sendToDb()}
				className={"rounded-lg border border-2 p-2 w-full border-gray"}
				readOnly={readOnly}
			/>
		</form>
	);
};

export default CurrencyInput;
